import { EventSettings } from '@/types/projects.types';

const checkIfProjectCreatedFromTemplate = (settings?: EventSettings): boolean => {
  if (!settings?.template) return false;
  if (!settings?.created_from_template_project?.length) return false;

  // return project.settings.template === project.settings.created_from_template_project.findLast(() => true);
  return !!(settings.template && settings.created_from_template_project.length);
};

export default checkIfProjectCreatedFromTemplate;
